import { composeISOFromLocal, isValidDateStr, isValidTimeStr, todayLocalDate } from "./dateTime";
import { prepareSurveyForPersist, downloadJsonObject, normalizeSurveyDropdownOptions } from "./surveyPersistence";

export function createHandleChange(setSurvey, i18n) {
    return (e) => {
        // e can be a native event or a synthetic object { target: { name, value, ... }, lng?: 'pl' }
        const target = e?.target || {};
        const { name, value, type, checked, dataset } = target;
        if (["title", "description", "shortDescription"].includes(name)) {
            const langOverride = (e && e.lng) || (dataset && dataset.lng);
            const lang = langOverride || (i18n?.language) || 'pl';
            setSurvey((prev) => ({
                ...prev,
                [name]: { ...prev[name], [lang]: value },
            }));
            return;
        }
        setSurvey((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };
}

export function createPublishDateOnChange({ setPublishDateStr, getPublishTimeStr, setSurvey }) {
    return (e) => {
        const v = e.target.value;
        setPublishDateStr(v);
        const timeStr = getPublishTimeStr() || "00:00";
        if (isValidDateStr(v) && isValidTimeStr(timeStr)) {
            const iso = composeISOFromLocal(v, timeStr);
            setSurvey((prev) => ({ ...prev, publishAt: iso }));
        }
    };
}

export function createPublishTimeOnChange({ setPublishTimeStr, getPublishDateStr, setSurvey }) {
    return (e) => {
        const v = e.target.value;
        setPublishTimeStr(v);
        const dateStr = getPublishDateStr() || todayLocalDate();
        if (isValidTimeStr(v) && isValidDateStr(dateStr)) {
            const iso = composeISOFromLocal(dateStr, v);
            setSurvey((prev) => ({ ...prev, publishAt: iso }));
        }
    };
}

export function createEndDateOnChange({ setEndDateStr, getEndTimeStr, setSurvey }) {
    return (e) => {
        const v = e.target.value;
        setEndDateStr(v);
        const timeStr = getEndTimeStr() || "00:00";
        if (isValidDateStr(v) && isValidTimeStr(timeStr)) {
            const iso = composeISOFromLocal(v, timeStr);
            setSurvey((prev) => ({ ...prev, endSurvey: iso }));
        }
    };
}

export function createEndTimeOnChange({ setEndTimeStr, getEndDateStr, setSurvey }) {
    return (e) => {
        const v = e.target.value;
        setEndTimeStr(v);
        const dateStr = getEndDateStr() || todayLocalDate();
        if (isValidTimeStr(v) && isValidDateStr(dateStr)) {
            const iso = composeISOFromLocal(dateStr, v);
            setSurvey((prev) => ({ ...prev, endSurvey: iso }));
        }
    };
}

// Language toggle handler removed per new requirements

export function createHandleSave({ getSurvey, id, LANGS, t, updateSurvey }) {
    return () => {
        const prepared = prepareSurveyForPersist(getSurvey(), id, LANGS);
        updateSurvey(id, prepared)
            .then(() => alert(t("survey.saveSuccess")))
            .catch((err) => alert(t("survey.saveError") + ": " + err.message));
    };
}

export function createHandleDownload({ getSurvey, id, LANGS, t }) {
    return () => {
        try {
            const prepared = prepareSurveyForPersist(getSurvey(), id, LANGS);
            const sid = String(id);
            downloadJsonObject(prepared, `survey_${sid}.json`);
        } catch (e) {
            alert(t('survey.downloadError', { defaultValue: 'Nie udało się pobrać JSON.' }) + `\n${e?.message || e}`);
        }
    };
}

export function createHandleFileChange({ setSurvey, t }) {
    return (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onload = () => {
            try {
                const text = reader.result?.toString() || '';
                const parsed = JSON.parse(text);
                const normalized = normalizeSurveyDropdownOptions({ ...parsed });
                setSurvey(normalized);
                alert(t('survey.uploadSuccess', { defaultValue: 'Załadowano JSON ankiety.' }));
            } catch (err) {
                alert(t('survey.uploadError', { defaultValue: 'Nieprawidłowy plik JSON.' }) + `\n${err?.message || err}`);
            } finally {
                e.target.value = '';
            }
        };
        reader.onerror = () => {
            alert(t('survey.uploadError', { defaultValue: 'Nieprawidłowy plik JSON.' }));
            e.target.value = '';
        };
        reader.readAsText(file);
    };
}

export function createHandleUploadClick(fileInputRef) {
    return () => fileInputRef.current?.click();
}
